export const ServiceName = {
    Clio: 'clio',
    Muse: 'muse',
    Iris: 'iris',
    Spa: 'spa',
    Uikit: 'ui-kit',
};
